module.exports = __webpack_public_path__ + "img/humidity.06770360.svg";